import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { fetchFullDatasetwithfilters } from '../../redux/datasets/datasets.actions';
import { toggleSessionCreate } from '../../redux/user/user.actions';
import { get, dateDiff, getConfig, getText } from '../../helpers';
import extractId from '../../utilities/extract-id';
import keyPages from '../../utilities/key-pages';
import Dataset from './dataset';
import history from '../../utilities/history';
import buildUrl from '../../utilities/build-url';

const apiDataRefreshTime = getConfig('redux.cacheRefreshTimes.long');
const langCode = getText('langCode');
const mapStateToProps = (state: RootStoreState, ownProps: PageProps & DatasetProps): PageProps & DatasetProps & FeatureFlags => {
    const url = get(ownProps, 'match.params.id', false);
    const datasetId = url && extractId(url);
    if (datasetId === '1000003' && url.startsWith('fda-data-suite-')) {
        history.push(`/${langCode}/datasets/fda-adverse-event-reporting-system-faers-(110)`);
    } else if (datasetId === 0) history.push(`/${langCode}/404`);
    const isBundle = get(ownProps, 'match.path', '') === '/:locale/datasets/bundle/:id';
    const fullDataSetPath = isBundle ? `datasets.full.${datasetId}-B.response` : `datasets.full.${datasetId}-D.response`;
    const fullDataset = get(state, fullDataSetPath, false);
    const fflagEnableWorkbench = get(state, 'shared.flags.fflagEnableWorkbench');
    const solutions = get(state, 'solutions.openSearch.response', []) as APISolution[];
    const solution = solutions.find((s: APISolution) => (s.AbsoluteSolutionName || s.MktplaceSolutionName).indexOf('Workbench') > 0) || {} as APISolution;
    const name = solution.AbsoluteSolutionName || solution.MktplaceSolutionName || '';
    const solutionPathSegment = buildUrl(name, solution.KeyPlatformService || '');
    const solutionurl = solution.KeyPlatformService ? `/solutions/${solutionPathSegment}` : '';

    if (fullDataset) {
        return {
            user: state.user,
            dataProfile: (dateDiff(fullDataset.cachedTime) < apiDataRefreshTime) && fullDataset,
            id: Number(datasetId),
            keyPage: keyPages.datasetPage,
            isBundle: fullDataset.isBundle,
            startDate: undefined,
            fflagEnableWorkbench,
            solutionurl
        };
    }

    const catalogue = get(state, 'datasets.openSearch.response', []);

    if (catalogue.length > 0) {
        const initialDataset = catalogue.find((item: DataProfile) => item.id === Number(datasetId) && item.isBundle === isBundle) || false;
        if (!initialDataset) {
            history.push(`/${langCode}/404`);
        }
    }

    return {
        user: state.user,
        id: Number(datasetId),
        keyPage: keyPages.datasetPage,
        isBundle,
        startDate: undefined,
        fflagEnableWorkbench,
        solutionurl
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): DatasetActions => ({
    toggleSessionCreate: (IsSessionCreated: boolean) => {
        dispatch(toggleSessionCreate(IsSessionCreated));
    },
    fetchFullDataProfile: (params: DatasetParams) => {
        dispatch(fetchFullDatasetwithfilters(params));
    }
});

const mergeProps = (pageProps: PageProps, datasetActions: DatasetActions, ownProps: DatasetProps) => ({
    ...pageProps,
    ...datasetActions,
    ...ownProps
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Dataset);
